import { render, staticRenderFns } from "./allowSaleProduct.vue?vue&type=template&id=d886ad96&scoped=true&"
import script from "./allowSaleProduct.vue?vue&type=script&lang=js&"
export * from "./allowSaleProduct.vue?vue&type=script&lang=js&"
import style0 from "./allowSaleProduct.vue?vue&type=style&index=0&id=d886ad96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d886ad96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d886ad96')) {
      api.createRecord('d886ad96', component.options)
    } else {
      api.reload('d886ad96', component.options)
    }
    module.hot.accept("./allowSaleProduct.vue?vue&type=template&id=d886ad96&scoped=true&", function () {
      api.rerender('d886ad96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/allowSaleProduct.vue"
export default component.exports